import React, { useContext, useEffect, useMemo, useState } from 'react';
import dayjs from 'dayjs';
import Cross from 'assets/svg/Cross';
import EditPencilOutlined from 'assets/svg/EditPencilOutlined';
import { FilterContextData } from 'contexts/FilterContext';
import { FilterSelectionProps, priceSimulatorDataContext } from 'contexts/PriceSimulatorContext';
import DownSelected from 'assets/svg/DownSelected';
import { trackEventMixpanel } from 'utils/mixpanel';
import { PSR_SIMULATION_FILTER_TOGGLED } from 'utils/mixpanelEventNames';

const SimulationFilter = () => {
    const [expand, setExpand] = useState(false);

    const { allCheckedAttribute, setExpandFilterBol } = useContext(FilterContextData);
    const {
        viewMode,
        globalFilters = [],
        setGlobalFilters,
        simulationDateRange,
        priceEffectiveDate,
        selectedDataSource,
    } = useContext(priceSimulatorDataContext);

    const dateLabel = useMemo(() => {
        let startLabel = 'Start Date';
        let endLabel = 'End Date';
        if (simulationDateRange[0]) startLabel = dayjs(new Date(simulationDateRange[0])).format('MM/DD/YYYY');
        if (simulationDateRange[1]) endLabel = dayjs(new Date(simulationDateRange[1])).format('MM/DD/YYYY');
        return { startLabel, endLabel };
    }, [simulationDateRange]);

    const priceEffectiveDateLabel = useMemo(() => {
        let startLabel = 'Start Date';
        if (priceEffectiveDate[1]) startLabel = dayjs(new Date(priceEffectiveDate[1])).format('MM/DD/YYYY');
        return startLabel;
    }, [priceEffectiveDate]);

    useEffect(() => {
        if (!viewMode) {
            const filters: Array<any> = [];

            if (selectedDataSource.value !== '') {
                filters.push({
                    title: 'Data Source',
                    selectedItems: [`${selectedDataSource.label}`],
                    hideEditIcon: true,
                });
            }
            if (dateLabel.startLabel !== 'Start Date') {
                filters.push({
                    title: 'Simulation Period',
                    selectedItems: [`${dateLabel.startLabel}-${dateLabel.endLabel}`],
                    hideEditIcon: true,
                });
            }
            if (priceEffectiveDateLabel !== 'Start Date') {
                filters.push({
                    title: 'Price Effective date',
                    selectedItems: [priceEffectiveDateLabel],
                    hideEditIcon: true,
                });
            }
            Object.keys(allCheckedAttribute || {}).forEach((filterKey: any) => {
                if (Object.keys(allCheckedAttribute[filterKey] || {}).length > 0) {
                    const filter: FilterSelectionProps = {
                        title: filterKey,
                        selectedItems: Object.keys(allCheckedAttribute[filterKey]),
                    };
                    filters.push(filter);
                }
            });
            setGlobalFilters(filters);
        }
    }, [allCheckedAttribute, viewMode, simulationDateRange, priceEffectiveDate, selectedDataSource]);

    return (
        <div className="mb-2 rounded bg-bgBackground" id="price-sim-filter">
            {globalFilters?.length === 0 ? (
                <div className="text-greyFont  p-3">
                    Global filter products and attributes selection will be shown here
                </div>
            ) : (
                <>
                    {!expand && (
                        <div
                            className="flex overflow-x-hidden p-3 justify-between items-center rounded cursor-pointer"
                            onClick={() => {
                                setExpand(!expand);
                                trackEventMixpanel(PSR_SIMULATION_FILTER_TOGGLED);
                            }}
                        >
                            <div className="flex overflow-x-hidden">
                                {globalFilters?.slice(0, 3).map((gf: FilterSelectionProps) => {
                                    return (
                                        <div className="flex mr-4" key={gf.title}>
                                            <span className="font-medium text-purpleFont mr-1"> {gf?.title}: </span>
                                            <span className="text-greyFont flex font-normal">
                                                {gf?.selectedItems
                                                    ?.slice(0, 3)
                                                    .map((item: string, index: number, arr: string[]) => (
                                                        <div>
                                                            <span> {item}</span>
                                                            {arr?.length - 1 !== index && (
                                                                <span className="mr-1">, </span>
                                                            )}
                                                        </div>
                                                    ))}
                                                {gf?.selectedItems?.length > 3 && (
                                                    <div className="flex">
                                                        <span className="mr-2">...</span>
                                                        <span className="text-purpleFont">
                                                            +{gf?.selectedItems?.length - 3} more
                                                        </span>
                                                    </div>
                                                )}
                                            </span>
                                        </div>
                                    );
                                })}
                            </div>
                            <div className="ml-2 cursor-pointer">
                                <DownSelected />
                            </div>
                        </div>
                    )}
                    {expand && (
                        <div className="bg-purple-200 p-3 rounded">
                            <div
                                className="flex  bg-purple-200 justify-end items-center cursor-pointer"
                                onClick={() => {
                                    setExpand(!expand);
                                    trackEventMixpanel(PSR_SIMULATION_FILTER_TOGGLED);
                                }}
                            >
                                <span className="cursor-pointer">
                                    <Cross />
                                </span>
                            </div>
                            <div className="flex ">
                                <div className="flex flex-col h-24 overflow-y-scroll w-full">
                                    {globalFilters.map((gf: FilterSelectionProps) => {
                                        return (
                                            <div className="flex mb-2 ">
                                                <span className="font-medium text-purpleFont mr-1 font-xs">
                                                    {gf?.title}
                                                </span>
                                                <span className="text-greyFont flex flex-grow flex-wrap font-normal">
                                                    {gf?.selectedItems?.map(
                                                        (item: string, index: number, arr: string[]) => (
                                                            <span className="font-xs">
                                                                {item}
                                                                {arr?.length - 1 !== index && (
                                                                    <span className="mr-1">, </span>
                                                                )}
                                                            </span>
                                                        ),
                                                    )}
                                                    {!viewMode && !gf.hideEditIcon && (
                                                        <span
                                                            className="cursor-pointer ml-2 flex justify-center items-center"
                                                            onClick={() => {
                                                                setExpandFilterBol(false);
                                                            }}
                                                        >
                                                            <EditPencilOutlined customIndex={1} />
                                                        </span>
                                                    )}
                                                </span>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default SimulationFilter;
